import React from 'react'

interface IProps {
  agentValue: any
  profile: any
}

const AgentProfile: React.FC<IProps> = ({ agentValue, profile }) => {
  console.log(agentValue)

  const statusClass = agentValue[0]?.status === 'ACTIVE' ? 'bg-success' : 'bg-danger'

  return (
    <>
      <div className='card card-xl-stretch mb-xl-8'>
        <div className='card-header border-0 pt-5'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold fs-3 mb-1'>User Profile</span>
          </h3>
        </div>

        {/* <!--begin::Card body--> */}
        <div className='card-body'>
          <div className='d-flex flex-center flex-column'>
            {/* <!--begin::Avatar--> */}
            <div className='symbol symbol-100px symbol-circle mb-2'>
              <span className='symbol-label fs-3x fw-semibold'>
                <img
                  src={agentValue[0]?.image}
                  alt={`${agentValue[0]?.name}'s avatar`}
                  className='img-fluid'
                  style={{ borderRadius: '50%' }}
                />
              </span>
              <div
                className={`position-absolute border border-4 border-body h-20px w-20px rounded-circle translate-middle start-100 top-90 ms-n5 mt-n3 ${statusClass}`}
              ></div>
            </div>
            {/* <!--end::Avatar--> */}

            {/* <!--begin::Name--> */}
            <a href='#' className='fs-4 text-gray-800 text-hover-primary fw-bold mb-0'>
              {agentValue[0]?.name}
            </a>
            {/* <!--end::Name--> */}

            {/* <!--begin::Position--> */}
            <div className='fw-semibold  mb-1'>Customer Support Specialist</div>
            {/* <!--end::Position--> */}

            {/* <!--begin::Agent Level--> */}
            {agentValue[0]?.occupancyPercentage && (
              <div className='fw-semibold  mb-2'>
                {' '}
                Occupancy percentage: {agentValue[0]?.occupancyPercentage}
              </div>
            )}
            {agentValue[0]?.occupancyGoal && (
              <div className='fw-semibold  mb-2'>
                {' '}
                Occupancy goal:{agentValue[0]?.occupancyGoal}
              </div>
            )}

            <div className='fw-semibold text-gray-500 mb-2'>{agentValue[0]?.agentLevel}</div>

            {/* <!--end::Agent Level--> */}
          </div>

          {/* <!--begin::Info--> */}
          <div className='card-footer d-flex justify-content-evenly p-0 pt-4'>
            <div className='d-flex flex-column align-items-center'>
              <span className='fs-4 text-gray-800 text-hover-primary fw-bold mb-0'>Email</span>
              <span className='fw-semibold text-gray-500'>{agentValue[0]?.email}</span>
            </div>
            <div className='d-flex flex-column align-items-center'>
              <span className='fs-4 text-gray-800 text-hover-primary fw-bold mb-0'>
                Employee ID
              </span>
              <span className='fw-semibold text-gray-500'>{agentValue[0]?.employeeId}</span>
            </div>
            <div className='d-flex flex-column align-items-center'>
              <span className='fs-4 text-gray-800 text-hover-primary fw-bold mb-0'>Mobile</span>
              <span className='fw-semibold text-gray-500'>{agentValue[0]?.mobile}</span>
            </div>
          </div>
          {/* <!--end::Info--> */}
        </div>
        {/* <!--end::Card body--> */}
      </div>
    </>
  )
}

export default AgentProfile
